module.exports = {
  ANDES_BLUE_500: '#3483FA',
};
